module.exports = __webpack_public_path__ + "static/ROBdownarrow-68db5dda5c62965970e460794860ed4a.png";